import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import type { EnvironmentProviders } from '@angular/core';
import { inject, makeEnvironmentProviders, PLATFORM_ID, provideAppInitializer } from '@angular/core';

import type { DevScenario } from '@arya/shared/domain';

import { DEV_SCENARIOS } from './dev-scenarios';
import { scenarioConsole } from './scenario-console';

export const provideScenarioConsole = (scenarios: readonly DevScenario[]): EnvironmentProviders =>
  makeEnvironmentProviders([
    { provide: DEV_SCENARIOS, useValue: scenarios },
    provideAppInitializer(() => {
      const document = inject(DOCUMENT);
      const view = document.defaultView;
      if (!isPlatformBrowser(inject(PLATFORM_ID)) || view === null) return;
      Object.assign(view, { noxo: { scenarios: scenarioConsole(document, scenarios) } });
    }),
  ]);
